// src/components/auth/SocialAuthButtons.jsx
// Boutons de connexion sociale (Google / Apple / Facebook) — style Groupon.
// AbodyStudio Limited - https://abodystudio.com
//
// Les boutons lancent le flux OAuth côté serveur (/api/auth/<provider>).
// Si les identifiants OAuth ne sont pas configurés sur le serveur, celui-ci
// redirige proprement vers /login?social=unavailable&provider=... (géré par la page Login).
import React from 'react';
import { FaGoogle } from 'react-icons/fa';
import API from '../../services/api';

const oauthBase = () => {
  const base = (API && API.defaults && API.defaults.baseURL) ? API.defaults.baseURL : '/api';
  return String(base).replace(/\/$/, '');
};

const startOAuth = (provider) => {
  // Navigation pleine page : le serveur gère la redirection OAuth.
  window.location.href = `${oauthBase()}/auth/${provider}`;
};

const PROVIDERS = [
  { key: 'google', label: 'Continuer avec Google', Icon: FaGoogle, iconClass: 'text-[#EA4335]' }
  // Apple / Facebook masqués tant que leurs identifiants OAuth ne sont pas
  // configurés (évite un bouton qui mène à une erreur). Les réactiver ici
  // quand prêts : { key: 'facebook', ... }, { key: 'apple', ... }
];

const SocialAuthButtons = ({ className = '' }) => {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {PROVIDERS.map(({ key, label, Icon, iconClass }) => (
        <button
          key={key}
          type="button"
          onClick={() => startOAuth(key)}
          className="w-full flex items-center justify-center gap-3 px-4 py-2.5 rounded-full border border-gray-300 bg-white text-gray-800 font-medium hover:bg-gray-50 transition"
          aria-label={label}
        >
          <Icon className={iconClass} size={18} />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};

export default SocialAuthButtons;
